import { gql } from "@apollo/client";

export const StateTypesInputTypeDef = gql`
  enum State {
    Active
    Banned
    NotActive
  }
`;
export const TrafficSourceTypesInputTypeDef = gql`
  enum TrafficSource {
    EmailTraffic
    GoogleAds
    Other
    Outbrain
    PPC
    SEOTraffic
    SocialMedia
  }
`;

export const TrafficTypeInputTypeDef = gql`
  enum TrafficType {
    Data
    Live
  }
`;

export const YearsOfExperienceInputTypeDef = gql`
  enum YearsOfExperience {
    LessThan1
    MoreThan5
    Years1or2
    Years2OrMoreLess5
  }
`;

export const AffiliateBankInputTypeDef = gql`
  input AffiliateBankInput {
    accountNumber: String
    address: String
    beneficiaryAddress: String
    beneficiaryName: String
    iban: String
    name: String
    swift: String
  }
`;

export const AffiliateCompanyInputTypeDef = gql`
  input AffiliateCompanyInput {
    address: String
    name: String
    regNumber: String
    vatId: String
  }
`;

export const AffiliateGeneralInfoBaseInputTypeDef = gql`
  input AffiliateGeneralInfoBaseInput {
    currency: Currency
    state: State
    trafficSource: TrafficSource
    trafficType: TrafficType
    yearsOfExperience: YearsOfExperience
    zipCode: String
  }
`;

export const AffiliateUserInfoBaseInputTypeDef = gql`
  input AffiliateUserInfoBaseInput {
    email: String!
    messenger: String
    messengerType: MessengerType
    notes: String
    phone: String
    username: String!
  }
`;
